import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { FaArrowDownLong } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { Link } from "react-scroll";
import "../../App.css";
import "./homeAbout2.css";

gsap.registerPlugin(ScrollTrigger);

const HomeAbout2 = ({ whyData, whatData, checkSelfData, participateData }) => {
  const firstDivRef = useRef(null);
  const secondDivRef = useRef(null);
  const thirdDivRef = useRef(null);
  const [showPopUp, setShowPopUp] = useState(false);

  let sum3UserAccessToken = localStorage.getItem("sum3UserAccessToken");
  let sum3UserRole = localStorage.getItem("sum3UserRole");

  useEffect(() => {
    const right = document.querySelector(".secondDivRight");
    const left = document.querySelector(".secondDivLeft");
    const text = document.querySelector(".secondDivText");
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            right.classList.add("active");
            left.classList.add("active");
            text.classList.add("active");
          }, 500);
        } else {
          right.classList.remove("active");
          left.classList.remove("active");
          text.classList.remove("active");
        }
      },
      { rootMargin: "0px", threshold: 0.5 }
    );
    if (secondDivRef.current) {
      observer.observe(secondDivRef.current);
    }
    return () => {
      if (secondDivRef.current) {
        observer.unobserve(secondDivRef.current);
      }
    };
  }, [secondDivRef]);

  useEffect(() => {
    const right = document.querySelector(".thirdDivRight");
    const left = document.querySelector(".thirdDivLeft");
    const text = document.querySelector(".thirdDivText");
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            right.classList.add("active");
            left.classList.add("active");
            text.classList.add("active");
          }, 500);
        } else {
          right.classList.remove("active");
          left.classList.remove("active");
          text.classList.remove("active");
        }
      },
      { rootMargin: "0px", threshold: 0.5 }
    );
    if (thirdDivRef.current) {
      observer.observe(thirdDivRef.current);
    }
    return () => {
      if (thirdDivRef.current) {
        observer.unobserve(thirdDivRef.current);
      }
    };
  }, [thirdDivRef]);

  const navigate = useNavigate();
  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      const horizontalSections = gsap.utils.toArray(".dim");
      gsap.to(horizontalSections, {
        xPercent: -100 * (horizontalSections.length - 1),
        ease: "none",
        scrollTrigger: {
          trigger: "#container",
          pin: true,
          scrub: 1,
          snap: 1 / (horizontalSections.length - 1),
          end: () => "+=" + document.querySelector("#container").offsetWidth,
        },
      });
    });

    return () => ctx.revert();
  }, []);

  return (
    <div class="mt-5">
      <div className="horizontal" id="container">
        <div className="dim" style={{ background: "#ffffff" }}>
          <div className="firstDiv" ref={firstDivRef}>
            <div className="firstDivDown">
              <img src={require("../../Images/downArow.png")} alt="" />
            </div>
            <div className="firstDivUp">
              <img src={require("../../Images/upArow.png")} alt="" />
            </div>
            <div className="firstDivText">
              <p class="mfs-7 text-nowrap fw-semibold">{whyData?.bottom_txt}</p>
            </div>
            <Link
              activeClass="active"
              to={"home7"}
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
            >
              <button class="homeDownBtn bg-dark">
                <p>
                  <FaArrowDownLong class="fw-bold" />
                </p>
              </button>
            </Link>
            <div class="col-lg-9 col-10" style={{ zIndex: "1" }}>
              <p class="mfs-8 fweb text-white">{whyData?.title}</p>
              <div
                class="tJustify mfs-4 fwsb"
                dangerouslySetInnerHTML={{
                  __html: whyData?.text,
                }}
              />
            </div>
          </div>
        </div>
        <div className="dim" style={{ background: "#402E32" }}>
          <div className="thirdDiv " ref={thirdDivRef}>
            <div className="thirdDivRight">
              <img src={require("../../Images/right.png")} alt="" />
            </div>
            <div className="thirdDivLeft">
              <img src={require("../../Images/left.png")} alt="" />
            </div>
            <div className="thirdDivText">
              <p class="mfs-7 text-nowrap fw-semibold"> HOW TO PARTICIPATE</p>
            </div>

            <div
              class="col-lg-11 row gap-lg-0  gap-2  justify-content-center"
              style={{ zIndex: "1" }}
            >
              {participateData?.map((item, index) => (
                <div
                  class={`col-lg-4 my-lg-${index === 1 ? "5" : "1"}`}
                  key={item.id}
                >
                  <div
                    class="col-11 rounded-4 text-start m-auto "
                    style={{ border: "1px solid #000" }}
                  >
                    <div class="col-11 m-auto my-3">
                      <p class="htp1 fweb">{item.no}</p>
                      <p class="htp2 fweb">{item.title}</p>
                      <p class="htp3 fwel">{item.text}</p>
                      {!sum3UserAccessToken && !sum3UserRole && (
                        <button
                          class="sumBtn mfs-4 rounded-5 mt-3"
                          onClick={() => navigate(item.button_url || "/log-in")}
                        >
                          {item.button_name || "Sign up"}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="dim" style={{ background: "#FFF5F0" }}>
          <div className="secondDiv" ref={secondDivRef}>
            <div className="secondDivRight">
              <img src={require("../../Images/right.png")} alt="" />
            </div>
            <div className="secondDivLeft">
              <img src={require("../../Images/left.png")} alt="" />
            </div>
            <div className="secondDivText">
              <p class="mfs-7 text-nowrap  fw-semibold">
                {whatData?.bottom_txt}
              </p>
            </div>

            <div class="col-lg-9 col-10" style={{ zIndex: "1" }}>
              <p class="mfs-8 fweb text-white">{whatData?.title}</p>
              <div
                class="tJustify mfs-4 fwsb"
                dangerouslySetInnerHTML={{
                  __html: whatData?.text,
                }}
              />
            </div>
          </div>
        </div>
        <div className="dim">
          <div className="forthDiv">
            <div class="col-lg-10 col-11">
              <p class="mfs-8 fwt  " style={{ color: "#EDEDED" }}>
                {checkSelfData?.title1} <br />
                <span class="fweb ctaText" style={{ color: "#FF823C" }}>
                  {checkSelfData?.title2}
                </span>{" "}
                <br /> {checkSelfData?.title3 || "AND"} <br />{" "}
                <span class="fweb ctaText" style={{ color: "#FF823C" }}>
                  {checkSelfData?.title4}{" "}
                </span>
              </p>
              <button
                class="sumBtn mfs-4 my-4  rounded-5"
                onClick={() => setShowPopUp(true)}
              >
                {checkSelfData?.button_name}
              </button>
            </div>
          </div>
        </div>
        
      </div>
      {showPopUp ? (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{
              position: "fixed",
              height: "100vh",
              width: "100%",
              top: "0",
              left: "0",
              background: "rgba(0,0,0,0.8)",
              zIndex: "9999",
              backdropFilter: "blur(10px)",
            }}
          >
            <div style={{ height: "90%", width: "100%", overflowY: "auto" }}>
              <div className="col-11 text-white m-auto">
                <div className="d-flex align-items-center justify-content-end">
                  <i
                    className="bi bi-x-circle fs-3"
                    onClick={() => setShowPopUp(false)}
                    style={{ cursor: "pointer" }}
                  ></i>
                </div>
                <div className="text-start fs-5">
                  <p className="fs-4">
                    <b>
                      {checkSelfData?.title1} {checkSelfData?.title2}{" "}
                      {checkSelfData?.title3} {checkSelfData?.title4}
                    </b>
                  </p>
                  <p className="mt-2 tJustify">
                    Would you rather save a few dollars by cutting corners, or
                    invest in a trading experience that truly supports your growth
                    and success?
                  </p>
                  <p className="mt-2 tJustify">
                    <b>Value Real Services—</b>like{" "}
                    <b>
                      {" "}
                      free live trading signals, expert copy trading, mindset
                      coaching, one-on-one consultations,{" "}
                    </b>
                    and <b>learning new trading techniques.</b>
                  </p>
                  <p className="mt-2 tJustify">
                    If small savings of 1/2 pips in spread is more important to
                    you than these invaluable services, then perhaps another
                    platform is for you. But let's be real—those minor savings
                    usually disappear easily in market movements and slippage that
                    go unnoticed to the naked eye. (if you didn't understand what
                    that meant, Welcome to 3SUM!)
                  </p>
                  <p className="mt-2 tJustify">
                    At 3Sum, we believe in offering more than just superficial
                    savings. We provide the tools and support that make a real
                    difference in your trading journey as a package. Many
                    providers entice you with promises of saving few dollars per
                    trade with thinner spreads, no holding costs etc— this is
                    great if you're trading millions and perhaps billions every
                    month. But for most new traders, those days are far off, and
                    the truth is, many never reach that level because the cost of
                    trade off is the right platform, the proper understanding of
                    trading basics, and the tools to effectively leverage trading
                    technology.
                  </p>
                  <button
                    className="sumBtn mfs-4 rounded-5 mt-3"
                    onClick={() => setShowPopUp(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        ):''}
    </div>
  );
};

export default HomeAbout2;
